'use strict'
const React = require('react');

class SidebarNav extends React.Component {	
	
	renderSubAccountMenu() {
		return (
			<li className="has-sub">
				<a href="#">
					<i className="fas fa-key fa-fw" />
					<span>Sub-cuenta</span>
				</a>
				<ul>
					<li>
						<a href="/subaccount/list">
							<i className="fas icon-spacer fa-fw" />
							<span>Lista de cuentas</span>
						</a>
					</li>
					<li>
						<a href="/activity-logs">
							<i className="fas icon-spacer fa-fw" />
							<span>Mi historial</span>
						</a>
					</li>
				</ul>
			</li>
		);
	}

	renderMerchantSubAccountMenu() {
		if (this.props.isMerchantSubAccountActive) {
			return this.renderSubAccountMenu();
		}	
		return;
	}

	renderMerchantNav() {
		return (
			<ul className="sidebar-nav">
		        <li>
		            <a href="/merchants/dashboard">
		            	<i className="fas fa-tachometer-alt fa-fw" />
		            	<span>Dashboard</span>
		            </a>
		        </li>
		        <li>
		            <a href="/merchants/items">
			            <i className="fas fa-cubes fa-fw" />
			            <span>Mis productos</span>
		            </a>
		        </li>
		        <li>
		            <a href="/merchants/upload">
		            	<i className="fas fa-plus fa-fw" />
		            	<span>Agregar producto</span>
		            </a>
		        </li>
		        <li className="has-sub">
		            <a href="#">
		            	<i className="fas fa-file-alt fa-fw" />
		            	<span>Documentos</span>
		            </a>
		            <ul>
		            	<li>
	                        <a active-on-route="/quotation" href="/quotation/list">
	                        	<i className="fas icon-spacer fa-fw" />
	                        	<span>Cotizaciones</span>
	                        </a>
	                    </li>
		                <li>
		                    <a active-on-route="/merchants/order" href="/merchants/order/history">
		                    	<i className="fas icon-spacer fa-fw" />
		                    	<span>Purchase Order</span>
		                    </a>
		                </li>
		            </ul>
		        </li>
		        {this.renderMerchantSubAccountMenu()}
		        <li>
		            <a active-on-route="/delivery" href="/delivery/settings">
		            	<i className="fas fa-shipping-fast fa-fw" />
		            	<span>Envío</span>
		            </a>
		        </li>
	    	</ul>
	    )
	}

	renderBuyerNav() {
		return (
			<ul className="sidebar-nav">
	            <li>
	                <a href="/">
	                	<i className="fas fa-home fa-fw"/>
	                	<span>Inicio</span>
	                </a>
	            </li>
	            <li className="has-sub">
	                <a href="#">
	                	<i className="fas fa-file-alt fa-fw" />
	                	<span>Documentos</span>
	                </a>
	                <ul>
	                	<li>
							<a active-on-route="/quotation/" href="/quotation/list?buyer=true">
	                        	<i className="fas icon-spacer fa-fw" />
	                        	<span>Cotizaciones</span>
	                        </a>
	                    </li>
	                    <li>
	                        <a active-on-route="/purchase" href="/purchase/history">
	                        	<i className="fas icon-spacer fa-fw" />
	                        	<span>Historial de ordenes</span>
	                        </a>
	                    </li>
	                </ul>
	            </li>
	            {this.renderSubAccountMenu()}
	        </ul>
		);
	}

	render() {
		return (
			<React.Fragment>
				{
					typeof this.props.isMerchant !== 'undefined' ?
						this.props.isMerchant == true ? this.renderMerchantNav() : this.renderBuyerNav()
					: ''
				}

			</React.Fragment>
		)
	}
}

module.exports = SidebarNav;